<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Confirm</h1>
			</div>
		</div>

    <div id="content">
      <div class="types">
        <h2>Types</h2>
        
        <h3>Warning</h3>
        <div class="right">
          <mt-button @click="warningConfirm">Warning</mt-button>
        </div>

        <h3>Success</h3>
        <div class="right">
          <mt-button @click="successConfirm">Success</mt-button>
        </div>

        <h3>Error</h3>
        <div class="right">
          <mt-button @click="errorConfirm">Error</mt-button>
        </div>
      </div>

      <div class="style">
        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height427">
          <img :src="warningColor" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Buttons bar: #F6F7FA</p>
          <p>Icon: #FFC107</p>
          <p>Button: #FFC107</p>
          <p>Text: #485464</p>
          <p>Subtle button: #485464 opacity 80% </p>
        </div>
        <div class="mt--clearfix"></div>

        <div class="left mt--bg--neutrals-light-gray-01 height427">
          <img :src="successColor" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Buttons bar: #F6F7FA</p>
          <p>Icon: #00C853</p>
          <p>Button: #055AFE</p>
          <p>Text: #485464</p>
          <p>Subtle button: #485464 opacity 80% </p>
        </div>
        <div class="mt--clearfix"></div>

        <div class="left mt--bg--neutrals-light-gray-01 height427">
          <img :src="errorColor" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Buttons bar: #F6F7FA</p>
          <p>Icon: #00C853</p>
          <p>Button: #055AFE</p>
          <p>Text: #485464</p>
          <p>Subtle button: #485464 opacity 80% </p>
        </div>
        <div class="mt--clearfix"></div>

        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height427">
          <img :src="sizing" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Corner radius: 4px</p>
          <p>Width: 400px</p>
          <p>Height: auto</p>
          <p>border: 0.5px</p>
          <p>Font size: 18px</p>
          <p>Line height: 26px</p>
          <p>Font size(sentence): 16px</p>
          <p>Line height(sentence): 24px</p>
        </div>

        <h3>Position</h3>
        <div class="position mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="position" alt="">
        </div>

      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: 'confirm-page',
  data () {
    return {
      warningColor: require('@/assets/confirm-style-warning.svg'),
      successColor: require('@/assets/confirm-style-success.svg'),
      errorColor: require('@/assets/confirm-style-error.svg'),
      sizing: require('@/assets/confirm-sizing-small.svg'),
      position: require('@/assets/confirm-position.svg'),
    }
  },
  methods: {
    warningConfirm() {
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Small button',
        cancelButtonText: 'Subtle',
        type: 'warning'
      })
      .then((res) => {
        //confirm
      })
      .catch(() => {
        //cancel
      })
    },
    successConfirm() {
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Small button',
        cancelButtonText: 'Subtle',
        type: 'success'
      })
      .then(() => {
        //confirm
      })
      .catch(() => {
        //cancel
      })
    },
    errorConfirm() {
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Small button',
        cancelButtonText: 'Subtle',
        type: 'error'
      })
      .then(() => {
        //confirm
      })
      .catch(() => {
        //cancel
      })
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  line-height: 1.57;
  margin: 0;
}
h3 { font-size: 16px; }
.types .right {
  width: 30%;
  padding: 2%;
  float: right;
  height: 94px;
  .button-wrap{
    padding-right: 20px;
  }
}
.styles {
  margin: 0 auto;
  width: 78%;
}
.right {
  padding: 2%;
  float: left;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 730px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.height427 { height: 427px; }
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
}
.position {
  width: 730px;
  height: 432px;
}

</style>



// WEBPACK FOOTER //
// Confirm.vue?9c6f0a5e